export default "__VITE_PUBLIC_ASSET__4d068016__"